module.exports = __webpack_public_path__ + "media/images/icons/icon_stars-915b997388d47a74d8bbf85cf3dd9ffb.svg";